<div class="flex flex-column gap-2" [formGroup]="form">
  <app-input-number name="numeroCampionamentoAnnuoInternoPrevisto" label="Controlli interni" [form]="form"></app-input-number>
  <app-input-number name="numeroCampionamentoAnnuoEsterniPrevisto" label="Controlli esterni" [form]="form"></app-input-number>
</div>
